<!-- eslint-disable -->
<template>

    <div class="card card-custom card-stretch gutter-b">
        <!--begin::Header-->
        <div class="card-header border-0 py-5">
            <h3 class="card-title align-items-start flex-column">
                <span class="card-label font-weight-bolder text-dark">Варианты товара</span>
                <span class="text-muted mt-3 font-weight-bold font-size-sm">
                    Варианты товара — это уникальные наборы опций товара, которые отличаются друг от друга.<br>
                    Чтобы сделать уникальный вариант, нужно добавить свойства в атрибуте (например, цвет, размер, и т.д)<br>
                    и создать вариант, указав ему конкретный цвет, размер, цену и любое другое свойство.</span>
            </h3>
            <div class="card-toolbar">
                <a @click="addVariantOpen" class="btn btn-primary font-weight-bolder font-size-sm disabled"><!--end::Svg Icon-->Добавить вариант</a>
            </div>
        </div>
        <!--end::Header-->

        <!--begin::Body-->
        <div class="card-body pt-0 pb-3">
            <!--begin::Table-->
            <div class="table-responsive">
                <table class="table table-head-custom table-head-bg table-borderless table-vertical-center">
                    <thead>
                    <tr class="text-uppercase">
                        <th>Фото</th>
                        <th>Артикул</th>
                        <th>Цена</th>
                        <th v-if="product.type === 'in_stock'">Количество</th>
                        <th>Набор свойств</th>
                        <th></th>
                    </tr>
                    </thead>

                    <template v-for="(variant, i) in product.variants" >
                        <VariationsProductItem v-bind:key="i"
                                :variant="variant"
                                :product="product"
                                @delete_variant="delVarOpen"
                                @edit_variant="editVariant"
                        />
                    </template>

                </table>
            </div>



            <b-modal id="select-image" ref="select-image-var" title="Выберете изображение" ok-only>

                <div v-if="product.images.length === 0 " role="alert" class="alert alert-danger text-white text-center">
                    <strong><i class="fa fa-info-circle"></i> У товара нет изображений!</strong>
                </div>

                <ul v-else class="ui-sortable">
                    <li v-bind:key="i" class="image" v-for="(pr, i) in product.images" >
                        <b-img v-if="!checkSelect(pr.image_id)" @click="selectImage(pr)" thumbnail fluid :src="$urlBackEnd(pr.thumbnail)" alt="Image" style="cursor: pointer"></b-img>
                        <b-img v-else @click="removeImage(pr.image_id)" thumbnail fluid :src="$urlBackEnd(pr.thumbnail)" alt="Image" style="cursor: pointer"></b-img>

                        <i v-if="checkSelect(pr.image_id)" style="background-color: #079300" class="fas fa-check"></i>
                    </li>
                </ul>
            </b-modal>

            <b-modal ref="edit-variant" size="xl" centered hide-footer :title="titleModal()">
                <div class="d-block">


                    <h4 class="card-title font-weight-bolder text-dark">Изображения варианта</h4>
                    <b-container v-if="variant.images.length > 0" fluid class="p-4 mb-3 bg-dark">
                        <ul class="ui-sortable">
                            <draggable :list="variant.images" v-bind="{animation:400}">
                                <li v-bind:key="i" class="image" v-for="(pr, i) in variant.images" >
                                    <b-img  thumbnail fluid :src="$urlBackEnd(pr.thumbnail)" alt="Image 1"></b-img>
                                    <i @click="removeImage(pr.image_id)" class="fas fa-trash-alt"></i>
                                </li>
                            </draggable>
                        </ul>
                    </b-container>

                    <vue-dropzone ref="myVueDropzone"
                                  id="dropzone"
                                  :options="dropzoneOptions"
                                  :useCustomSlot=true
                                  v-on:vdropzone-success="successDrop"
                                  v-on:vdropzone-max-files-exceeded="maxDrop"
                    >
                        <div class="dropzone-custom-content">
                            <b class="dropzone-custom-title">Загрузите файлы</b>
                            <div class="subtitle">...или перетащите их сюда</div>
                        </div>
                    </vue-dropzone>

                    <b-button block v-b-modal.select-image class="my-2" variant="primary">Или выберите загруженные изображения</b-button>


                    <div class="form-group mb-2">
                        <b-form-group class="mb-2" description="Введите артикул варианта" label="Артикул:">
                            <b-form-input v-model.trim="variant.sku" :class="{'is-invalid': errors.sku}" required></b-form-input>
                            <div v-if="errors.sku" class="invalid-feedback">{{errors.sku[0]}}</div>
                        </b-form-group>
                    </div>
                    <div v-if="product.type === 'in_stock'" class="form-group mb-2">
                        <b-form-group class="mb-2" description="Введите количество" label="Количество:">
                            <b-form-input v-model.number="variant.stock" :class="{'is-invalid': errors.stock}" required></b-form-input>
                            <div v-if="errors.stock" class="invalid-feedback">{{errors.stock[0]}}</div>
                        </b-form-group>
                    </div>



                    <div class="card card-custom card-stretch gutter-b">
                        <!--begin::Header-->
                        <div class="card-header border-0 py-5">
                            <h3 class="card-title align-items-start flex-column">
                                <span class="card-label font-weight-bolder text-dark">Цена</span>
                                <span class="text-muted mt-3 font-weight-bold font-size-sm">
                                        Формирование цены от города и срока доставки
                                    </span>
                            </h3>
                        </div>
                        <!--end::Header-->
                        <div class="card-body pt-0 pb-3">
                            <div class="align-items-center mb-10">

                                <div class="form-group row mb-0">
                                    <b-form-group class="col-lg-12 mb-2" label="Скидка:">
                                        <b-form-checkbox size="lg" v-model.number="variant.sale" :value="1" :unchecked-value="0">
                                            Включить скидку на вариант
                                        </b-form-checkbox>
                                    </b-form-group>
                                </div>

                                    <div class="form-group row mb-0">

                                        <b-form-group class="mb-2 col-6" description="Введите цену варианта" label="Цена:">
                                            <b-form-input v-model.number="variant.price" :class="{'is-invalid': errors.price}" :placeholder="String(product.price)"></b-form-input>
                                            <div v-if="errors.price" class="invalid-feedback">{{errors.price[0]}}</div>
                                        </b-form-group>


                                        <b-form-group class="col-6 mb-2" description="Введите цену скидки варианта" label="Скидка:">
                                            <b-form-input v-model.number="variant.discount" :class="{'is-invalid': errors.discount}" :placeholder="String(product.discount)"></b-form-input>
                                            <div v-if="errors.discount" class="invalid-feedback">{{errors.discount[0]}}</div>
                                        </b-form-group>

                                    </div>


                                    <div class="row align-items-center mt-3">
                                        <div class="col-md-4 my-2 my-md-0">
                                            <b-form-select
                                                    class="mb-2 mr-sm-2 mb-sm-0"
                                                    :value="null"
                                                    v-model="add_city"
                                                    :class="{'is-invalid': errorsAddCity}"
                                            >
                                                <option :value="null">Выберите город</option>
                                                <option value="all">Добавить все города</option>
                                                <option value="product">Добавить из товара</option>
                                                <template v-for="(city, i) in cities" >
                                                    <option v-bind:key="i"
                                                            :value="city"
                                                            :disabled="disabledCity(city.id)"
                                                    >{{city.name}}</option>
                                                </template>
                                            </b-form-select>
                                        </div>
                                        <div class="col-md-4 my-2 my-md-0">
                                            <b-button @click="addCityToProduct" ref="add_attribute_product" variant="primary">Добавить город(а)</b-button>
                                        </div>
                                    </div>
                            </div>

                            <draggable :list="variant.cities" v-bind="{animation:400}" :tag="'div'" handle=".hand">
                                <template v-for="city in variant.cities" >
                                    <div class="card card-custom card-stretch gutter-b">

                                        <div class="card-body pt-4 pb-3">

                                            <div class="form-group row mb-3">
                                                <b-form-group class="col-lg-6 mb-2" label="Город:">
                                                    <b-form-input v-model.trim="city.name" :class="{'is-invalid': errors.price}"></b-form-input>
                                                    <div v-if="errors.price" class="invalid-feedback">{{errors.price[0]}}</div>
                                                </b-form-group>

                                                <b-form-group class="col-lg-6 mb-2" label="Стоимость доставки:">
                                                    <b-form-input v-model.number="city.price" :class="{'is-invalid': errors.price}"></b-form-input>
                                                    <div v-if="errors.price" class="invalid-feedback">{{errors.price[0]}}</div>
                                                </b-form-group>
                                            </div>

                                            <div class="table-responsive">
                                                <table class="table table-head-custom table-head-bg table-borderless table-vertical-center">
                                                    <thead>
                                                    <tr class="text-uppercase">
                                                        <th>Метод</th>
                                                        <th>Кол-во дней</th>
                                                        <th>Цена метода поставки</th>
                                                        <th>Итого цена за еденицу измерения</th>
                                                        <th>Итого цена за лот</th>
                                                    </tr>
                                                    </thead>
                                                    <tr v-for="method in city.methods">
                                                        <td>
                                                            <b-form-input v-model.trim="method.name" :class="{'is-invalid': errors.price}"></b-form-input>
                                                            <div v-if="errors.price" class="invalid-feedback">{{errors.price[0]}}</div>
                                                        </td>

                                                        <td>
                                                            <b-form-input v-model.number="method.days" :class="{'is-invalid': errors.price}"></b-form-input>
                                                            <div v-if="errors.price" class="invalid-feedback">{{errors.price[0]}}</div>
                                                        </td>

                                                        <td>
                                                            <b-form-input v-model.number="method.price" :class="{'is-invalid': errors.price}"></b-form-input>
                                                            <div v-if="errors.price" class="invalid-feedback">{{errors.price[0]}}</div>
                                                        </td>

                                                        <td>
                                                            <b-form-input v-model.number="method.totalUnitPrice" :class="{'is-invalid': errors.price}"></b-form-input>
                                                            <div v-if="errors.price" class="invalid-feedback">{{errors.price[0]}}</div>
                                                        </td>

                                                        <td>
                                                            <b-form-group class="mb-2">
                                                                <div class="input-group">
                                                                    <div class="input-group-prepend">
                                                                        <button @click="updateTotalPricePerLot(method)" v-b-tooltip.hover title="Расчитать цену за лот" class="btn btn-primary" type="button"><i class="fas fa-sync-alt"></i></button>
                                                                    </div>
                                                                    <b-form-input
                                                                            v-model.number="method.totalPricePerLot"
                                                                            required
                                                                    ></b-form-input>
                                                                </div>
                                                            </b-form-group>
                                                        </td>

                                                    </tr>
                                                </table>
                                            </div>

                                            <div class="col-md-6 my-2 my-md-0">
                                                <b-button style="cursor: move;" size="sm" class="mr-2 hand"><i class="fas fa-arrows-alt-v"></i> Изменить порядок</b-button>
                                                <b-button @click="showDeleteCityModal(city)" size="sm" variant="danger">Удалить город</b-button>
                                            </div>

                                        </div>
                                    </div>
                                </template>

                            </draggable>
                        </div>
                    </div>


                    <div class="card card-custom card-stretch gutter-b">

                        <div class="card-body">
                            <h3 class="font-weight-bold font-size-h4 text-dark-75 mb-3">Набор свойств</h3>
                            <div class="font-size-sm mb-6">Назначьте уникальные свойства для этого варианта</div>

                            <div v-if="product.attributes.length === 0 && variant.attributes.length === 0" role="alert" class="alert alert-warning alert-dismissible text-dark text-center">
                                <strong><i class="fa fa-info-circle"></i> Внимание!</strong>
                                <br>В этом товаре нет атрибутов.<br>Сначала добавьте атрибуты, а затем выберите опции для набора свойств варианта.
                            </div>
                            <div v-else>
                            <div class="row align-items-center mb-4">
                                <div class="col-md-8 my-2 my-md-0">
                                    <b-form-select class="mb-2 mr-sm-2 mb-sm-0" :value="null" v-model="add_attribute" :class="{'is-invalid': errorsAddAttribute}">

                                        <option :value="null">Выберите атрибут</option>
                                        <template v-for="(attribute, i) in product.attributes" >
                                            <option v-bind:key="i"
                                                    :value="attribute"
                                                    :disabled="disabledAttributes(attribute.id)"
                                            >{{attribute.attribute.name}}</option>
                                        </template>

                                    </b-form-select>
                                </div>
                                <div class="col-md-4 my-2 my-md-0">
                                    <b-button @click="addAttributeToVariant" ref="add_attribute_product" variant="primary">Добавить атрибут</b-button>
                                </div>
                            </div>

                            <hr>

                            <template v-for="(attribute, i) in variant.attributes" >
                                <div v-bind:key="i" class="d-flex mb-3">
                                    <span class="text-dark-50 py-2 flex-root font-weight-bold">{{attribute.name}}</span>


                                    <div v-if="attribute.type && attribute.type === 'color'" class="ml-auto text-muted font-weight-bold">
                                        <b-button
                                                :style="[ attribute.value !== null ? { backgroundColor: attribute.value.color} : {}]"
                                                style="min-width: 38px; min-height: 38px;"
                                                class="mr-2">
                                        </b-button>
                                    </div>

                                    <span class="text-dark flex-root font-weight-bold" style="max-width: 300px">
                                        <b-form-select class="mb-2 mr-sm-2 mb-sm-0" :value="null" v-model="attribute.value" :class="{'is-invalid': attribute.error}">
                                            <option v-if="attribute.options.length > 0" :value="null">Выбрать</option>
                                            <option v-else :value="null">В этом атрибуте нет опций</option>
                                            <template v-for="(option, i) in attribute.options" >
                                                <option v-bind:key="i"
                                                        :value="option"
                                                >{{option.name}}</option>
                                            </template>
                                        </b-form-select>
                                    </span>

                                    <b-link @click="deleteAttribute(attribute.id)" v-b-tooltip.hover title="Удалить атрибут" class="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"><i class="fas fa-trash-alt"></i></b-link>

                                </div>
                            </template>
                            </div>

                        </div>
                    </div>



                </div>

                <b-button ref="save_variant" class="mt-3" variant="outline-primary" block @click="saveVariant">
                    <template v-if="variantAction === 'edit'">
                        Сохранить
                    </template>
                    <template v-if="variantAction === 'add'">
                        Добавить вариант
                    </template>
                </b-button>

            </b-modal>



            <b-modal ref="delete-variant" centered hide-footer hide-header title="Подтвердите действие">
                <div class="d-block text-center">
                    <h3>Удалить вариант: #{{delete_var}}?</h3>
                </div>
                <b-row>
                    <b-col>
                        <b-button class="mt-3" variant="outline-primary" block @click="hideModalDelete">Отмена</b-button>
                    </b-col>
                    <b-col>
                        <b-button class="mt-3" variant="outline-danger" block @click="deleteVariant">Удалить</b-button>
                    </b-col>
                </b-row>
            </b-modal>

            <b-modal ref="delete-modal-city" centered hide-footer hide-header title="Подтвердите действие">
                <div class="d-block text-center">
                    <h3>Удалить город: {{deleteCity.name}}?</h3>
                </div>
                <b-row>
                    <b-col>
                        <b-button class="mt-3" variant="outline-primary" block @click="hideDeleteCityModal">Отмена</b-button>
                    </b-col>
                    <b-col>
                        <b-button class="mt-3" variant="outline-danger" block @click="deleteCityMethod">Удалить</b-button>
                    </b-col>
                </b-row>
            </b-modal>

            <!--end::Table-->
        </div>
        <!--end::Body-->
    </div>

</template>

<script>
    import { mapGetters } from "vuex";
    import VariationsProductItem from "./VariationsProductItem";
    import vue2Dropzone from 'vue2-dropzone';
    import draggable from 'vuedraggable';
    import {
        ADD_VARIATION,
        DELETE_VARIATION, SET_VARIATIONS_ERROR,
        UPDATE_VARIATION,
        VALIDATION_VARIATION
    } from "../../../../core/services/store/variations.module";
    import {SET_ALERT} from "../../../../core/services/store/alert.module";
    export default {
        name: "VariationsProduct",
        components: {
            vueDropzone: vue2Dropzone,
            VariationsProductItem,
            draggable
        },
        props: [ 'product'],
        computed: {
            ...mapGetters({
                errors: 'errorsVariation',
                cities: 'gettersCities',
            }),

            currentRouteName() {
                return this.$route.name;
            },
        },

        data(){
            return{

                add_attribute: null,
                errorsAddAttribute: false,
                variantAction: 'add',
                add_city: null,
                errorsAddCity: false,
                deleteCity: {
                    id: null,
                    name: ''
                },

                variant: {
                    images: [],
                    price: '',
                    sku: '',
                    stock: '',
                    attributes: [],
                    cities:[]
                },
                add_var: {
                    images: [],
                    price: '',
                    sku: '',
                    stock: '',
                    attributes: [],
                    cities:[]
                },

                delete_var: '',
                vari: '',


                dropzoneOptions: {
                    url: this.$urlBackEnd('/api/v1/product/images'),
                    acceptedFiles: '.jpg, .jpeg, .png,',
                    thumbnailWidth: 200,
                    maxFilesize: 8,
                    maxFiles:50,
                    headers: { "Authorization": 'Bearer ' + localStorage.getItem('id_token') },
                    parallelUploads: 1,
                    createImageThumbnails: true,
                    uploadMultiple: false,
                },
            }
        },

        methods:{

            action(){
                return this.$route.params.action
            },

            titleModal(){
                if (this.variantAction === 'edit') {
                    return 'Редактировать вариант'
                } else if (this.variantAction === 'add') {
                    return 'Добавить вариант'
                }
            },

            successDrop (file, response) {
                this.$refs.myVueDropzone.removeFile(file);

                const img = {
                    image_id: response.id,
                    src: response.original,
                    thumbnail: response.thumbnail,
                };

                if (this.variant.images === null){
                    this.variant.images = []
                }

                this.variant.images.push(img);
            },

            disabledCity(id){
                if (this.variant.cities){
                    if (this.variant.cities.find(obj => obj.id === id)){
                        return true
                    }
                }
            },


            addCityToProduct(){
                if (this.add_city && this.add_city !== 'null') {
                    this.errorsAddCity = false;
                    if (this.add_city === 'all'){

                        let addCities = 0;

                        this.cities.forEach( city => {
                            if (!this.variant.cities.find(obj => obj.id === city.id)) {
                                this.variant.cities.push(city);
                                addCities++
                            }
                        });

                        if (addCities > 0){
                            this.showAlert(`Добавленное кол-во городов: ${addCities}`, 'success', 'toast');
                            this.add_city = null
                        } else {
                            this.showAlert('Ошибка! Такие города уже добавлены', 'danger', 'toast');
                            this.add_city = null
                        }

                    } else if (this.add_city === 'product'){
                        if(this.product.cities.length > 0){
                            let addCities = 0;
                            this.product.cities.forEach( city => {
                                if (!this.variant.cities.find(obj => obj.id === city.id)) {
                                    const p = this.lodash.cloneDeep(city);
                                    this.variant.cities.push(p);
                                    addCities++
                                }
                            });

                            if (addCities > 0){
                                this.showAlert(`Добавленное кол-во городов: ${addCities}`, 'success', 'toast');
                                this.add_city = null
                            } else {
                                this.showAlert('Ошибка! Такие города уже добавлены', 'danger', 'toast');
                                this.add_city = null
                            }
                        } else {
                            this.showAlert('Ошибка! В товаре нет городов', 'danger', 'toast');
                            this.add_city = null
                        }


                    } else {
                        this.variant.cities.push(this.add_city);
                        this.add_city = null;
                    }

                } else {
                    this.errorsAddCity = true;
                    this.showAlert('Необходимо выбрать город', 'warning', 'toast');
                }
            },

            updateTotalPricePerLot(item){
                let sum = Number(item.totalUnitPrice) * Number(this.product.minimum_lot);
                item.totalPricePerLot = +sum.toFixed(2)
            },

            showDeleteCityModal(city){
                this.deleteCity = {
                    id: city.id,
                    name: city.name,
                };
                this.$refs['delete-modal-city'].show()
            },

            hideDeleteCityModal(){
                this.$refs['delete-modal-city'].hide()
            },

            deleteCityMethod(){
                const indexToRemove = this.variant.cities.findIndex(obj => obj.id === this.deleteCity.id);
                this.variant.cities.splice(indexToRemove , 1);
                this.hideDeleteCityModal()
            },

            selectImage(image){

                const img = {
                    image_id: image.image_id,
                    src: image.src,
                    thumbnail: image.thumbnail,
                };

                if (this.variant.images === null){
                    this.variant.images = []
                }

                this.variant.images.push(img);

            },


            maxDrop (){

            },

            checkSelect(id){
                if (this.variant.images.find(img => img.image_id === id)){
                    return true
                }
            },

            editVariant(variant){
                this.$store.commit(SET_VARIATIONS_ERROR, {});
                this.errorsAddAttribute = false;
                this.variantAction = 'edit';
                this.variant = this.lodash.cloneDeep(variant);
                this.$refs['edit-variant'].show()
            },

            addVariantOpen(){
                this.$store.commit(SET_VARIATIONS_ERROR, {});
                this.errorsAddAttribute = false;
                this.variantAction = 'add';
                this.clearAddVariant();
                this.$refs['edit-variant'].show()
            },

            removeImage(id){
                const indexToRemove = this.variant.images.findIndex(obj => obj.image_id === id);
                this.variant.images.splice(indexToRemove , 1);
            },


            disabledAttributes(id){
                if (this.variant.attributes){
                    if (this.variant.attributes.find(obj => obj.id === id)){
                        return true
                    }
                }
            },



            deleteAttribute(id){
                const indexToDelete = this.variant.attributes.findIndex(obj => obj.id === id);
                this.variant.attributes.splice(indexToDelete, 1);
                this.showAlert('Атрибут успешно удален из варианта ', 'success', 'toast');

            },

            addAttributeToVariant(){

                if (this.add_attribute && this.add_attribute !== 'null') {
                    this.errorsAddAttribute = false;

                    var errors = false;
                    var _ = this;
                    this.variant.attributes.forEach(function (attribute) {
                        if(attribute.attribute_id === _.add_attribute.attribute_id){
                            errors = true;
                        }
                    });


                    if (errors === false) {

                        const att = {
                            id: this.add_attribute.id,
                            attribute_id: this.add_attribute.attribute_id,
                            product_id: this.product.id,
                            type: this.add_attribute.image == '1' ? this.add_attribute.image_type : this.add_attribute.attribute.type,
                            name: this.add_attribute.attribute.name,
                            options: this.add_attribute.options,
                            value: null,
                            error: false,
                        };

                        this.variant.attributes.push(att);
                        this.add_attribute = null;
                        this.showAlert('Атрибут успешно добавлен ', 'success', 'toast');
                    } else {
                        this.showAlert('Такой атрибут уже добавлен', 'warning', 'toast');
                    }
                } else {
                    this.errorsAddAttribute = true;
                    this.showAlert('Необходимо выбрать атрибут', 'warning', 'toast');
                }

            },

            showAlert(text, variant, type) {
                this.$store.commit(SET_ALERT, {text, variant, type});
            },


            closeEditOptions(){
                this.$refs['edit-variant'].hide()
            },

            clearAddVariant(){
                this.variant = this.lodash.cloneDeep(this.add_var);
            },

            delVarOpen(id){
                this.$refs['delete-variant'].show()
                this.delete_var = id
            },

            hideModalDelete(){
                this.$refs['delete-variant'].hide()
            },


            saveVariant(){

                const submitSaveVariant = this.$refs["save_variant"];
                submitSaveVariant.classList.add("spinner", "spinner-light", "spinner-right");

                this.variant.attributes.forEach(function (attribute) {
                    attribute.error = false;
                });

                if (String(this.variant.price).length < 1){
                    this.variant.price = this.product.price
                }

                this.spinner = true;
                var errors = false;
                var _ = this;
                this.variant.attributes.forEach(function (attribute) {
                    if(!attribute.value && attribute.value !== 'null'){
                        errors = true;
                        _.showAlert('Выберите опции атрибута: ' + attribute.name, 'warning', 'toast');
                        attribute.error = true;
                    }
                });

                if (errors !== true) {
                    if (this.action() === 'add') {
                        this.$store.dispatch(VALIDATION_VARIATION, this.variant)
                            .then((data) => {
                                if (this.variantAction === 'add'){
                                    this.$emit('add_variation', data.variation);
                                    this.showAlert('Атрибут успешно создан', 'success', 'toast');

                                } else if (this.variantAction === 'edit'){
                                    this.$emit('update_variation', data.variation);
                                    this.showAlert('Вариант успешно сохранен', 'success', 'toast');

                                }
                                this.closeEditOptions();
                                this.clearAddVariant()
                            })
                            .catch((response) => {
                                if (response.status === 422) {
                                    this.showAlert('Заполните все поля', 'danger', 'toast');
                                } else {
                                    this.showAlert('Ошибка! Вариант не был создан, попробуйте позже', 'danger', 'toast');
                                }
                            })
                            .finally(() => {
                                submitSaveVariant.classList.remove("spinner", "spinner-light", "spinner-right");
                            })
                    } else if (this.action() === 'edit') {
                        if (this.variantAction === 'add'){
                            this.$store.dispatch(ADD_VARIATION, {'product': this.product.id, 'variation': this.variant})
                                .then((data) => {
                                    this.$emit('add_variation', data.variation);
                                    this.closeEditOptions();
                                    this.showAlert('Вариант успешно создан', 'success', 'toast');
                                    this.clearAddVariant()

                                })
                                .catch((response) => {
                                    if (response.status === 422) {
                                        this.showAlert('Заполните все поля', 'danger', 'toast');
                                    } else {
                                        this.showAlert('Ошибка! Вариант не был создан, попробуйте позже', 'danger', 'toast');
                                    }
                                })
                                .finally(() => {
                                    submitSaveVariant.classList.remove("spinner", "spinner-light", "spinner-right");
                                })
                        } else if (this.variantAction === 'edit'){
                            this.$store.dispatch(UPDATE_VARIATION, {'id': this.variant.id, 'variation': this.variant})
                                .then((data) => {
                                    this.$emit('update_variation', data.variation);
                                    this.showAlert('Вариант успешно сохранен', 'success', 'toast');
                                    this.closeEditOptions();
                                })
                                .catch((response) => {
                                    if (response.status === 422) {
                                        this.showAlert('Заполните все поля', 'danger', 'toast');
                                    } else {
                                        this.showAlert('Ошибка! Вариант не был сохранен, попробуйте позже', 'danger', 'toast');
                                    }
                                })
                                .finally(() => {
                                    submitSaveVariant.classList.remove("spinner", "spinner-light", "spinner-right");
                                })
                        }

                    }
                } else {
                    submitSaveVariant.classList.remove("spinner", "spinner-light", "spinner-right");
                }
            },

            deleteVariant(){
                if (this.currentRouteName === 'AddProduct'){
                    this.$emit('delete_variation', this.delete_var);
                    this.showAlert('Вариант успешно удален', 'success', 'toast');
                    this.hideModalDelete()
                } else {
                    this.$store.dispatch(DELETE_VARIATION, this.delete_var)
                        .then((data) => {
                            if (data.result === true) {
                                this.$emit('delete_variation', this.delete_var);
                                this.showAlert('Вариант успешно удален', 'success', 'toast');
                                this.hideModalDelete()
                            }
                        })
                        .catch(() => {
                            this.showAlert('Ошибка! Вариант не был удален, попробуйте позже', 'danger', 'toast');
                        })
                }
            },
        }
    }
</script>

<style scoped>
    .ui-sortable .image{
        max-width: 100px;
        float: left;
        cursor: move;
        border: 1px solid #d5d5d5;
        margin: 9px 9px 0 0;
        background: #f7f7f7;
        border-radius: 2px;
        position: relative;
        box-sizing: border-box;
    }

    .ui-sortable {
        list-style: none;
        overflow:hidden
    }


    .ui-sortable i {
        cursor: pointer;
        position: absolute;
        background: red;
        padding: 6px;
        z-index: 5;
        color: #ffffff;
        font-size: 12px;
        border-radius: 5px;
        top: -4px;
        right: -4px;
    }



</style>